import { patchClinician } from "@/state/models/clinicians/operations";
import { useMutation } from "react-query";

export const usePatchClinician = () =>
	useMutation({ mutationFn: patchClinician });
